export const serviceType=[

        // {
        //     title: 'Recharge',
        //     icon: 'IconMobileRecharge',
        //     id: 'tab1',
        //     show: 'all',
        //     apiPermission: 'Recharge',
        //     link:"/dashboard"
        // },
    
        // {
        //     title: 'Credit Card',
        //     icon: 'IconCreditCard',
        //     id: 'tab3',
        //     show: 'all',
        //     apiPermission: 'CreditCard',
        //        link:"/dashboard"
        // },
        {
            title: 'Bill Payments',
            icon: 'IconBBPS',
            id: '',
            show: 'all',
            apiPermission: 'CreditCard',
               link:"/bbps-services"
        },
        // {
        //     title: 'Add Money',
        //     icon: 'IconAddmoney',
        //     id: 'tab8',
        //     show: 'all',
        //     apiPermission: 'Add_Money',
        //        link:"/dashboard"
        // },
    
        // {
        //     title: 'AEPS1',
        //     icon: 'IconAEPS',
        //     id: 'tab6',
        //     show: 'login',
        //     apiPermission: 'AEPS',
        //        link:"/dashboard"
        // },
        // {
        //     title: 'AEPS2',
        //     icon: 'IconAEPS',
        //     id: 'tab12',
        //     show: 'login',
        //     apiPermission: 'AEPS',
        //        link:"/dashboard"
        // },
        // {
        //     title: 'Aadhar Pay',
        //     icon: 'IconAadhayPay',
        //     id: 'tab11',
        //     show: 'login',
        //     apiPermission: 'AEPS',
        //        link:"/dashboard"
        // },
        // {
        // 	title: 'DMT 1',
        // 	icon: 'IconSendmoney',
        // 	id: 'tab7',
        // 	show:'all',
        // 	apiPermission:'SEND_MONEY',
        //    link:"/dashboard"
        // },
        // {
        //     title: 'DMT',
        //     icon: 'IconSendmoney',
        //     id: 'tab14',
        //     show:'all',
        //     apiPermission:'SEND_MONEY',
        //        link:"/dashboard"
        // },
    
        // {
        //     title: 'DTH',
        //     icon: 'IconDTH',
        //     id: 'tab5',
        //     show: 'all',
        //     apiPermission: 'DTH',
        //     link:"/dashboard"

        // },
        // {
        //     title: 'Electricity',
        //     icon: 'IconBillRecharge',
        //     id: 'tab2',
        //     show: 'all',
        //     apiPermission: 'Electricity',
        //      link:"/dashboard"

        // },
        // {
        //     title: 'Broadband',
        //     icon: 'IconBroadband',
        //     id: 'tab4',
        //     show: 'all',
        //     apiPermission: 'Broadband',
        //      link:"/dashboard"
        // },
    
        
        // {
        //     title: 'Water',
        //     icon: 'IconWater',
        //     id: 'tab10',
        //     show: 'all',
        //     apiPermission: 'Water',
        //      link:"/dashboard"
        // },
        // {
        //     title: 'Explore More',
        //     icon: 'IconExploreMore',
        //     id: 'tab9',
        //     show: 'all',
        //     apiPermission: '',
        //      link:"/dashboard"
        // },
        
    ];
    



